import './CreatedBy.css';
const CreatedBy = () => {
    return ( 
        <div className="createdBy">
            <h4>Created By <a href="https://github.com/adsyahir" rel="noreferrer" target="_blank">Adam Syahir</a>&nbsp;|&nbsp;<a href="http://www.adsyahir.com/index" rel="noreferrer" target="_blank">adsyahir.com</a></h4>
        </div>
     );
}
 
export default CreatedBy;